// setsByYear.js - Pokemon TCG sets organized by language and copyright year
// Ported from CardChase (React Native) setsByLanguage.tsx
// Used to narrow down TCGdex search based on copyright year and language detected on card

// Supported languages for TCGdex API
export const SUPPORTED_LANGUAGES = {
  en: { code: 'en', name: 'English', nativeName: 'English' },
  ja: { code: 'ja', name: 'Japanese', nativeName: '日本語' },
  fr: { code: 'fr', name: 'French', nativeName: 'Francais' },
  es: { code: 'es', name: 'Spanish', nativeName: 'Espanol' },
  it: { code: 'it', name: 'Italian', nativeName: 'Italiano' },
  'zh-tw': { code: 'zh-tw', name: 'Traditional Chinese', nativeName: '繁體中文' }
};

// English sets by year (TCGdex format IDs)
export const ENGLISH_SETS_BY_YEAR = {
  '2025': [
    { name: 'Prismatic Evolutions', id: 'sv08.5' },
    { name: 'Journey Together', id: 'sv09' }
  ],
  '2024': [
    { name: 'Surging Sparks', id: 'sv08' },
    { name: 'Stellar Crown', id: 'sv07' },
    { name: 'Shrouded Fable', id: 'sv06.5' },
    { name: 'Twilight Masquerade', id: 'sv06' },
    { name: 'Temporal Forces', id: 'sv05' },
    { name: 'Paldean Fates', id: 'sv04.5' }
  ],
  '2023': [
    { name: 'Paradox Rift', id: 'sv04' },
    { name: 'Pokemon 151', id: 'sv03.5' },
    { name: 'Obsidian Flames', id: 'sv03' },
    { name: 'Paldea Evolved', id: 'sv02' },
    { name: 'Scarlet & Violet', id: 'sv01' },
    { name: 'Crown Zenith', id: 'swsh12.5' }
  ],
  '2022': [
    { name: 'Silver Tempest', id: 'swsh12' },
    { name: 'Lost Origin', id: 'swsh11' },
    { name: 'Pokemon GO', id: 'pgo' },
    { name: 'Astral Radiance', id: 'swsh10' },
    { name: 'Brilliant Stars', id: 'swsh09' }
  ],
  '2021': [
    { name: 'Fusion Strike', id: 'swsh08' },
    { name: 'Celebrations', id: 'cel25' },
    { name: 'Evolving Skies', id: 'swsh07' },
    { name: 'Chilling Reign', id: 'swsh06' },
    { name: 'Battle Styles', id: 'swsh05' },
    { name: 'Shining Fates', id: 'swsh04.5' }
  ],
  '2020': [
    { name: 'Vivid Voltage', id: 'swsh04' },
    { name: "Champion's Path", id: 'swsh03.5' },
    { name: 'Darkness Ablaze', id: 'swsh03' },
    { name: 'Rebel Clash', id: 'swsh02' },
    { name: 'Sword & Shield', id: 'swsh01' }
  ],
  '2019': [
    { name: 'Cosmic Eclipse', id: 'sm12' },
    { name: 'Hidden Fates', id: 'sm11.5' },
    { name: 'Unified Minds', id: 'sm11' },
    { name: 'Unbroken Bonds', id: 'sm10' },
    { name: 'Detective Pikachu', id: 'det1' },
    { name: 'Team Up', id: 'sm09' }
  ],
  '2018': [
    { name: 'Lost Thunder', id: 'sm08' },
    { name: 'Dragon Majesty', id: 'sm07.5' },
    { name: 'Celestial Storm', id: 'sm07' },
    { name: 'Forbidden Light', id: 'sm06' },
    { name: 'Ultra Prism', id: 'sm05' }
  ],
  '2017': [
    { name: 'Crimson Invasion', id: 'sm04' },
    { name: 'Shining Legends', id: 'sm03.5' },
    { name: 'Burning Shadows', id: 'sm03' },
    { name: 'Guardians Rising', id: 'sm02' },
    { name: 'Sun & Moon', id: 'sm01' }
  ],
  '2016': [
    { name: 'Evolutions', id: 'xy12' },
    { name: 'Steam Siege', id: 'xy11' },
    { name: 'Fates Collide', id: 'xy10' },
    { name: 'Generations', id: 'g1' },
    { name: 'BREAKpoint', id: 'xy09' }
  ],
  '2015': [
    { name: 'BREAKthrough', id: 'xy08' },
    { name: 'Ancient Origins', id: 'xy07' },
    { name: 'Roaring Skies', id: 'xy06' },
    { name: 'Double Crisis', id: 'dc1' },
    { name: 'Primal Clash', id: 'xy05' }
  ],
  '2014': [
    { name: 'Phantom Forces', id: 'xy04' },
    { name: 'Furious Fists', id: 'xy03' },
    { name: 'Flashfire', id: 'xy02' },
    { name: 'XY', id: 'xy01' }
  ],
  '2013': [
    { name: 'Kalos Starter Set', id: 'xy00' },
    { name: 'Legendary Treasures', id: 'bw11' },
    { name: 'Plasma Blast', id: 'bw10' },
    { name: 'Plasma Freeze', id: 'bw09' },
    { name: 'Plasma Storm', id: 'bw08' }
  ],
  '2012': [
    { name: 'Boundaries Crossed', id: 'bw07' },
    { name: 'Dragon Vault', id: 'dv1' },
    { name: 'Dragons Exalted', id: 'bw06' },
    { name: 'Dark Explorers', id: 'bw05' },
    { name: 'Next Destinies', id: 'bw04' }
  ],
  '2011': [
    { name: 'Noble Victories', id: 'bw03' },
    { name: 'Emerging Powers', id: 'bw02' },
    { name: 'Black & White', id: 'bw01' },
    { name: 'Call of Legends', id: 'col1' }
  ],
  '2010': [
    { name: 'Triumphant', id: 'hgss04' },
    { name: 'Undaunted', id: 'hgss03' },
    { name: 'Unleashed', id: 'hgss02' },
    { name: 'HeartGold & SoulSilver', id: 'hgss01' }
  ],
  '2009': [
    { name: 'Arceus', id: 'pl4' },
    { name: 'Supreme Victors', id: 'pl3' },
    { name: 'Rising Rivals', id: 'pl2' },
    { name: 'Platinum', id: 'pl1' }
  ],
  '2008': [
    { name: 'Stormfront', id: 'dp7' },
    { name: 'Legends Awakened', id: 'dp6' },
    { name: 'Majestic Dawn', id: 'dp5' },
    { name: 'Great Encounters', id: 'dp4' }
  ],
  '2007': [
    { name: 'Secret Wonders', id: 'dp3' },
    { name: 'Mysterious Treasures', id: 'dp2' },
    { name: 'Diamond & Pearl', id: 'dp1' },
    { name: 'Power Keepers', id: 'ex16' }
  ],
  '2006': [
    { name: 'Dragon Frontiers', id: 'ex15' },
    { name: 'Crystal Guardians', id: 'ex14' },
    { name: 'Holon Phantoms', id: 'ex13' },
    { name: 'Legend Maker', id: 'ex12' }
  ],
  '2005': [
    { name: 'Delta Species', id: 'ex11' },
    { name: 'Unseen Forces', id: 'ex10' },
    { name: 'Emerald', id: 'ex09' },
    { name: 'Deoxys', id: 'ex08' }
  ],
  '2004': [
    { name: 'Team Rocket Returns', id: 'ex07' },
    { name: 'FireRed & LeafGreen', id: 'ex06' },
    { name: 'Hidden Legends', id: 'ex05' },
    { name: 'Team Magma vs Team Aqua', id: 'ex04' }
  ],
  '2003': [
    { name: 'Dragon', id: 'ex03' },
    { name: 'Sandstorm', id: 'ex02' },
    { name: 'Ruby & Sapphire', id: 'ex01' },
    { name: 'Skyridge', id: 'ecard3' },
    { name: 'Aquapolis', id: 'ecard2' }
  ],
  '2002': [
    { name: 'Expedition', id: 'ecard1' },
    { name: 'Legendary Collection', id: 'lc' },
    { name: 'Neo Destiny', id: 'neo4' }
  ],
  '2001': [
    { name: 'Neo Revelation', id: 'neo3' },
    { name: 'Neo Discovery', id: 'neo2' },
    { name: 'Neo Genesis', id: 'neo1' }
  ],
  '2000': [
    { name: 'Gym Challenge', id: 'gym2' },
    { name: 'Gym Heroes', id: 'gym1' },
    { name: 'Team Rocket', id: 'base4' },
    { name: 'Base Set 2', id: 'base6' }
  ],
  '1999': [
    { name: 'Fossil', id: 'base3' },
    { name: 'Jungle', id: 'base2' },
    { name: 'Base Set', id: 'base1' }
  ]
};

// Japanese sets by year (TCGdex format IDs)
export const JAPANESE_SETS_BY_YEAR = {
  '2025': [
    { name: 'バトルパートナーズ', id: 'SV9' },
    { name: 'テラスタルフェスex', id: 'SV8a' }
  ],
  '2024': [
    { name: '超電ブレイカー', id: 'SV8' },
    { name: '楽園ドラゴーナ', id: 'SV7a' },
    { name: 'ステラミラクル', id: 'SV7' },
    { name: 'ナイトワンダラー', id: 'SV6a' },
    { name: '変幻の仮面', id: 'SV6' },
    { name: 'クリムゾンヘイズ', id: 'SV5a' },
    { name: 'ワイルドフォース', id: 'SV5K' },
    { name: 'サイバージャッジ', id: 'SV5M' }
  ],
  '2023': [
    { name: 'シャイニートレジャーex', id: 'SV4a' },
    { name: '古代の咆哮', id: 'SV4K' },
    { name: '未来の一閃', id: 'SV4M' },
    { name: 'レイジングサーフ', id: 'SV3a' },
    { name: '黒炎の支配者', id: 'SV3' },
    { name: 'ポケモンカード151', id: 'SV2a' },
    { name: 'スノーハザード', id: 'SV2P' },
    { name: 'クレイバースト', id: 'SV2D' },
    { name: 'トリプレットビート', id: 'SV1a' },
    { name: 'スカーレットex', id: 'SV1S' },
    { name: 'バイオレットex', id: 'SV1V' }
  ],
  '2022': [
    { name: 'VSTARユニバース', id: 'S12a' },
    { name: 'パラダイムトリガー', id: 'S12' },
    { name: '白熱のアルカナ', id: 'S11a' },
    { name: 'ロストアビス', id: 'S11' },
    { name: 'ポケモンGO', id: 'S10b' },
    { name: 'ダークファンタズマ', id: 'S10a' },
    { name: 'タイムゲイザー', id: 'S10D' },
    { name: 'スペースジャグラー', id: 'S10P' },
    { name: 'バトルリージョン', id: 'S9a' },
    { name: 'スターバース', id: 'S9' }
  ],
  '2021': [
    { name: 'VMAXクライマックス', id: 'S8b' },
    { name: '25thアニバーサリーコレクション', id: 'S8a' },
    { name: 'フュージョンアーツ', id: 'S8' },
    { name: '蒼空ストリーム', id: 'S7R' },
    { name: '摩天パーフェクト', id: 'S7D' },
    { name: 'イーブイヒーローズ', id: 'S6a' },
    { name: '白銀のランス', id: 'S6H' },
    { name: '漆黒のガイスト', id: 'S6K' },
    { name: '双璧のファイター', id: 'S5I' },
    { name: '一撃マスター', id: 'S5a' },
    { name: '連撃マスター', id: 'S5R' }
  ],
  '2020': [
    { name: 'シャイニースターV', id: 'S4a' },
    { name: '仰天のボルテッカー', id: 'S4' },
    { name: 'ムゲンゾーン', id: 'S3' },
    { name: '爆炎ウォーカー', id: 'S2a' },
    { name: '反逆クラッシュ', id: 'S2' },
    { name: 'ソード', id: 'S1W' },
    { name: 'シールド', id: 'S1H' }
  ],
  '2019': [
    { name: 'タッグオールスターズ', id: 'SM12a' },
    { name: 'オルタージェネシス', id: 'SM12' },
    { name: 'ドリームリーグ', id: 'SM11b' },
    { name: 'リミックスバウト', id: 'SM11a' },
    { name: 'ミラクルツイン', id: 'SM11' },
    { name: 'スカイレジェンド', id: 'SM10b' },
    { name: 'ダブルブレイズ', id: 'SM10' },
    { name: 'フルメタルウォール', id: 'SM9b' },
    { name: 'タッグボルト', id: 'SM9' }
  ],
  '2018': [
    { name: '超爆インパクト', id: 'SM8' },
    { name: 'フェアリーライズ', id: 'SM7b' },
    { name: '迅雷スパーク', id: 'SM7a' },
    { name: '裂空のカリスマ', id: 'SM7' },
    { name: 'ドラゴンストーム', id: 'SM6b' },
    { name: 'ウルトラフォース', id: 'SM6a' }
  ],
  '2017': [
    { name: 'ウルトラサン', id: 'SM5S' },
    { name: 'ウルトラムーン', id: 'SM5M' },
    { name: '覚醒の勇者', id: 'SM4+' },
    { name: 'ひかる伝説', id: 'SM3+' },
    { name: '光を喰らう闇', id: 'SM3H' },
    { name: '闘う虹を見たか', id: 'SM3N' },
    { name: '新たなる試練の向こう', id: 'SM2+' },
    { name: 'キミを待つ島々', id: 'SM2K' },
    { name: 'アローラの月光', id: 'SM2L' }
  ],
  '2016': [
    { name: 'コレクションムーン', id: 'SM1M' },
    { name: 'コレクションサン', id: 'SM1S' },
    { name: 'ポケットモンスターカードゲーム 拡張パック 20th Anniversary', id: 'CP6' },
    { name: 'めざめる超王', id: 'XY10' },
    { name: '破天の怒り', id: 'XY9' },
    { name: '赤い閃光', id: 'XY8b' },
    { name: '青い衝撃', id: 'XY8a' }
  ],
  '2015': [
    { name: 'バンデットリング', id: 'XY7' },
    { name: 'エメラルドブレイク', id: 'XY6' },
    { name: 'マグマ団VSアクア団 ダブルクライシス', id: 'CP1' },
    { name: 'タイダルストーム', id: 'XY5a' },
    { name: 'ガイアボルケーノ', id: 'XY5b' },
    { name: 'ファントムゲート', id: 'XY4' },
    { name: 'ライジングフィスト', id: 'XY3' }
  ],
  '2014': [
    { name: 'ワイルドブレイズ', id: 'XY2' },
    { name: 'コレクションX', id: 'XY1a' },
    { name: 'コレクションY', id: 'XY1b' }
  ],
  '2010': [
    { name: '頂上大激突', id: 'L3' },
    { name: '強化パック ロストリンク', id: 'LL' },
    { name: 'よみがえる伝説', id: 'L2' },
    { name: 'ソウルシルバーコレクション', id: 'L1b' },
    { name: 'ハートゴールドコレクション', id: 'L1a' }
  ],
  '2007': [
    { name: 'ワールドチャンピオンズパック', id: 'PCG10' },
    { name: 'さいはての攻防', id: 'PCG9' }
  ],
  '2006': [
    { name: 'きせきの結晶', id: 'PCG8' },
    { name: 'ホロンの幻影', id: 'PCG7' },
    { name: 'ホロンの研究塔', id: 'PCG6' },
    { name: 'まぼろしの森', id: 'PCG5' },
    { name: '金の空、銀の海', id: 'PCG4' }
  ],
  '2005': [
    { name: 'ロケット団の逆襲', id: 'PCG3' },
    { name: '蒼空の激突', id: 'PCG2' },
    { name: '伝説の飛翔', id: 'PCG1' },
    { name: 'とかれた封印', id: 'ADV5' },
    { name: '強化拡張パックex1マグマVSアクア ふたつの野望', id: 'ADV4' }
  ],
  '2004': [
    { name: '天空の覇者', id: 'ADV3' },
    { name: '砂漠のきせき', id: 'ADV2' },
    { name: '拡張パック', id: 'ADV1' }
  ],
  '2002': [
    { name: '神秘なる山', id: 'E5' },
    { name: '裂けた大地', id: 'E4' },
    { name: '海からの風', id: 'E3' },
    { name: '地図にない町', id: 'E2' },
    { name: '基本拡張パック', id: 'E1' }
  ],
  '2001': [
    { name: 'ポケモンカード★web', id: 'web1' },
    { name: 'ポケモンカード★VS', id: 'VS1' },
    { name: '闇、そして光へ...', id: 'neo4' }
  ],
  '2000': [
    { name: 'めざめる伝説', id: 'neo3' },
    { name: '遺跡をこえて...', id: 'neo2' },
    { name: '金、銀、新世界へ...', id: 'neo1' }
  ],
  '1999': [
    { name: '闇からの挑戦', id: 'PMCG6' },
    { name: 'リーダーズスタジアム', id: 'PMCG5' }
  ],
  '1998': [
    { name: 'ロケット団', id: 'PMCG4' },
    { name: '化石の秘密', id: 'PMCG3' }
  ],
  '1997': [
    { name: 'ポケモンジャングル', id: 'PMCG2' }
  ],
  '1996': [
    { name: '拡張パック', id: 'PMCG1' }
  ]
};

// French sets by year (TCGdex format IDs)
export const FRENCH_SETS_BY_YEAR = {
  '2025': [
    { name: 'Partenaires de Combat', id: 'sv09' }
  ],
  '2024': [
    { name: 'Etincelles Deferlantes', id: 'sv08' },
    { name: 'Couronne Stellaire', id: 'sv07' },
    { name: 'Fable Ombree', id: 'sv06.5' },
    { name: 'Mascarade Crepusculaire', id: 'sv06' },
    { name: 'Forces Temporelles', id: 'sv05' },
    { name: 'Destinees de Paldea', id: 'sv04.5' }
  ],
  '2023': [
    { name: 'Faille Paradoxe', id: 'sv04' },
    { name: 'Ecarlate et Violet 151', id: 'sv03.5' },
    { name: 'Flammes Obsidiennes', id: 'sv03' },
    { name: 'Evolutions a Paldea', id: 'sv02' },
    { name: 'Ecarlate et Violet', id: 'sv01' },
    { name: 'Zenith Supreme', id: 'swsh12.5' }
  ],
  '2022': [
    { name: 'Tempete Argentee', id: 'swsh12' },
    { name: 'Origine Perdue', id: 'swsh11' },
    { name: 'Pokemon GO', id: 'pgo' },
    { name: 'Astres Radieux', id: 'swsh10' },
    { name: 'Etoiles Brillantes', id: 'swsh09' }
  ],
  '2021': [
    { name: 'Poing de Fusion', id: 'swsh08' },
    { name: 'Celebrations', id: 'cel25' },
    { name: 'Ciel en Evolution', id: 'swsh07' },
    { name: 'Regne de Glace', id: 'swsh06' },
    { name: 'Styles de Combat', id: 'swsh05' },
    { name: 'Destinees Radieuses', id: 'swsh04.5' }
  ],
  '2020': [
    { name: 'Voltage Eclatant', id: 'swsh04' },
    { name: 'La Voie du Maitre', id: 'swsh03.5' },
    { name: 'Tenebres Embrasees', id: 'swsh03' },
    { name: 'Clash des Rebelles', id: 'swsh02' },
    { name: 'Epee et Bouclier', id: 'swsh01' }
  ],
  '2019': [
    { name: 'Eclipse Cosmique', id: 'sm12' },
    { name: 'Destinees Occultes', id: 'sm11.5' },
    { name: 'Harmonie des Esprits', id: 'sm11' },
    { name: 'Liens Indefectibles', id: 'sm10' },
    { name: 'Detective Pikachu', id: 'det1' },
    { name: 'Duo de Choc', id: 'sm09' }
  ]
};

// Spanish sets by year (TCGdex format IDs)
export const SPANISH_SETS_BY_YEAR = {
  '2025': [
    { name: 'Companeros de Batalla', id: 'sv09' }
  ],
  '2024': [
    { name: 'Chispas Centelleantes', id: 'sv08' },
    { name: 'Corona Estelar', id: 'sv07' },
    { name: 'Fabula Sombria', id: 'sv06.5' },
    { name: 'Mascarada Crepuscular', id: 'sv06' },
    { name: 'Fuerzas Temporales', id: 'sv05' },
    { name: 'Destinos de Paldea', id: 'sv04.5' }
  ],
  '2023': [
    { name: 'Brecha Paradojica', id: 'sv04' },
    { name: 'Escarlata y Purpura 151', id: 'sv03.5' },
    { name: 'Llamas Obsidianas', id: 'sv03' },
    { name: 'Evoluciones en Paldea', id: 'sv02' },
    { name: 'Escarlata y Purpura', id: 'sv01' },
    { name: 'Cenit Supremo', id: 'swsh12.5' }
  ],
  '2022': [
    { name: 'Tempestad Plateada', id: 'swsh12' },
    { name: 'Origen Perdido', id: 'swsh11' },
    { name: 'Pokemon GO', id: 'pgo' },
    { name: 'Radiancia Astral', id: 'swsh10' },
    { name: 'Estrellas Brillantes', id: 'swsh09' }
  ],
  '2021': [
    { name: 'Puno Fusional', id: 'swsh08' },
    { name: 'Celebraciones', id: 'cel25' },
    { name: 'Cielos Evolutivos', id: 'swsh07' },
    { name: 'Reinado Escalofriante', id: 'swsh06' },
    { name: 'Estilos de Combate', id: 'swsh05' },
    { name: 'Destinos Brillantes', id: 'swsh04.5' }
  ],
  '2020': [
    { name: 'Voltaje Vivido', id: 'swsh04' },
    { name: 'Camino de Campeones', id: 'swsh03.5' },
    { name: 'Oscuridad Incandescente', id: 'swsh03' },
    { name: 'Choque Rebelde', id: 'swsh02' },
    { name: 'Espada y Escudo', id: 'swsh01' }
  ]
};

// Italian sets by year (TCGdex format IDs)
export const ITALIAN_SETS_BY_YEAR = {
  '2025': [
    { name: 'Compagni di Battaglia', id: 'sv09' }
  ],
  '2024': [
    { name: 'Scintille Folgoranti', id: 'sv08' },
    { name: 'Corona Astrale', id: 'sv07' },
    { name: 'Favola Velata', id: 'sv06.5' },
    { name: 'Crepuscolo Mascherato', id: 'sv06' },
    { name: 'Forze Temporali', id: 'sv05' },
    { name: 'Destino di Paldea', id: 'sv04.5' }
  ],
  '2023': [
    { name: 'Fenditura Paradosso', id: 'sv04' },
    { name: 'Scarlatto e Violetto 151', id: 'sv03.5' },
    { name: 'Fiamme Ossidiane', id: 'sv03' },
    { name: 'Evoluzioni a Paldea', id: 'sv02' },
    { name: 'Scarlatto e Violetto', id: 'sv01' },
    { name: 'Zenit Regale', id: 'swsh12.5' }
  ],
  '2022': [
    { name: 'Tempesta Argentata', id: 'swsh12' },
    { name: 'Origine Perduta', id: 'swsh11' },
    { name: 'Pokemon GO', id: 'pgo' },
    { name: 'Lucentezza Siderale', id: 'swsh10' },
    { name: 'Astri Lucenti', id: 'swsh09' }
  ],
  '2021': [
    { name: 'Colpo Fusione', id: 'swsh08' },
    { name: 'Celebrazioni', id: 'cel25' },
    { name: 'Evoluzioni Eteree', id: 'swsh07' },
    { name: 'Regno Glaciale', id: 'swsh06' },
    { name: 'Stili di Lotta', id: 'swsh05' },
    { name: 'Destino Splendente', id: 'swsh04.5' }
  ],
  '2020': [
    { name: 'Voltaggio Sfolgorante', id: 'swsh04' },
    { name: 'Cammino del Campione', id: 'swsh03.5' },
    { name: 'Fiamme Oscure', id: 'swsh03' },
    { name: 'Fragore Ribelle', id: 'swsh02' },
    { name: 'Spada e Scudo', id: 'swsh01' }
  ]
};

// Traditional Chinese sets by year (TCGdex format IDs)
export const CHINESE_SETS_BY_YEAR = {
  '2024': [
    { name: '超電突破', id: 'SV8' },
    { name: '樂園龍焰', id: 'SV7a' },
    { name: '星耀奇蹟', id: 'SV7' },
    { name: '暗夜漫遊者', id: 'SV6a' },
    { name: '變幻假面', id: 'SV6' },
    { name: '緋紅薄霧', id: 'SV5a' },
    { name: '荒野之力', id: 'SV5K' },
    { name: '數碼審判', id: 'SV5M' }
  ],
  '2023': [
    { name: '閃耀寶藏ex', id: 'SV4a' },
    { name: '古代咆哮', id: 'SV4K' },
    { name: '未來閃光', id: 'SV4M' },
    { name: '怒海激流', id: 'SV3a' },
    { name: '黑炎支配者', id: 'SV3' },
    { name: '寶可夢卡牌151', id: 'SV2a' },
    { name: '雪途危機', id: 'SV2P' },
    { name: '泥地衝擊', id: 'SV2D' },
    { name: '三連擊拍', id: 'SV1a' },
    { name: '朱紅ex', id: 'SV1S' },
    { name: '紫羅蘭ex', id: 'SV1V' }
  ],
  '2022': [
    { name: 'VSTAR宇宙', id: 'S12a' },
    { name: '範式觸發', id: 'S12' },
    { name: '白熱弧光', id: 'S11a' },
    { name: '失落深淵', id: 'S11' },
    { name: '寶可夢GO', id: 'S10b' },
    { name: '暗黑幻影', id: 'S10a' },
    { name: '時空觀測', id: 'S10D' },
    { name: '空間雜耍', id: 'S10P' },
    { name: '戰鬥地區', id: 'S9a' },
    { name: '星誕', id: 'S9' }
  ],
  '2021': [
    { name: 'VMAX巔峰', id: 'S8b' },
    { name: '25周年紀念收藏', id: 'S8a' },
    { name: '融合藝術', id: 'S8' },
    { name: '蒼空激流', id: 'S7R' },
    { name: '漆黑魂魄', id: 'S7D' },
    { name: '伊布英雄', id: 'S6a' },
    { name: '白銀長槍', id: 'S6H' },
    { name: '漆黑魂魄', id: 'S6K' },
    { name: '雙壁戰士', id: 'S5I' },
    { name: '一擊大師', id: 'S5a' },
    { name: '連擊大師', id: 'S5R' }
  ],
  '2020': [
    { name: '閃耀V', id: 'S4a' },
    { name: '驚天伏特擊', id: 'S4' },
    { name: '無限領域', id: 'S3' },
    { name: '爆焰行者', id: 'S2a' },
    { name: '叛逆衝突', id: 'S2' },
    { name: '劍', id: 'S1W' },
    { name: '盾', id: 'S1H' }
  ]
};

// Master object containing all languages
export const SETS_BY_LANGUAGE = {
  en: ENGLISH_SETS_BY_YEAR,
  ja: JAPANESE_SETS_BY_YEAR,
  fr: FRENCH_SETS_BY_YEAR,
  es: SPANISH_SETS_BY_YEAR,
  it: ITALIAN_SETS_BY_YEAR,
  'zh-tw': CHINESE_SETS_BY_YEAR
};

// Promo sets (not tied to specific year) - English
export const ENGLISH_PROMO_SETS = [
  { name: 'SWSH Black Star Promos', id: 'swshp' },
  { name: 'SM Black Star Promos', id: 'smp' },
  { name: 'SV Black Star Promos', id: 'svp' },
  { name: 'XY Black Star Promos', id: 'xyp' },
  { name: 'DP Black Star Promos', id: 'dpp' },
  { name: 'BW Black Star Promos', id: 'bwp' },
  { name: 'Nintendo Black Star Promos', id: 'np' },
  { name: 'Wizards Black Star Promos', id: 'basep' },
  { name: 'HGSS Black Star Promos', id: 'hgssp' },
];

// All promo sets by language
export const PROMO_SETS_BY_LANGUAGE = {
  en: ENGLISH_PROMO_SETS,
  // Japanese promos not available in TCGdex
  ja: [],
  fr: ENGLISH_PROMO_SETS, // French uses same promo IDs
  es: ENGLISH_PROMO_SETS,
  it: ENGLISH_PROMO_SETS,
  'zh-tw': [],
};

// Backward compatibility - default to English
export const SETS_BY_YEAR = ENGLISH_SETS_BY_YEAR;

// ============================================
// HELPER FUNCTIONS (Language-aware)
// ============================================

// Get the TCGdex API endpoint for a language
export const getTCGdexEndpoint = (language = 'en') => {
  const validLanguages = ['en', 'ja', 'fr', 'es', 'it', 'zh-tw', 'pt', 'de'];
  const lang = validLanguages.includes(language) ? language : 'en';
  return `https://api.tcgdex.net/v2/${lang}`;
};

// Get sets by year for a specific language
export const getSetsByYear = (year, language = 'en') => {
  const languageSets = SETS_BY_LANGUAGE[language] || ENGLISH_SETS_BY_YEAR;
  return languageSets[year] || [];
};

// Get all set IDs for a year (for TCGdex filtering)
export const getSetIdsByYear = (year, language = 'en') => {
  const sets = getSetsByYear(year, language);
  return sets.map(s => s.id);
};

// Find promo set by name or ID
export const findPromoSet = (searchName, language = 'en') => {
  if (!searchName) return null;

  const normalizedSearch = searchName.toLowerCase().trim();
  const promoSets = PROMO_SETS_BY_LANGUAGE[language] || ENGLISH_PROMO_SETS;

  for (const set of promoSets) {
    const normalizedSetName = set.name.toLowerCase();
    const normalizedSetId = set.id.toLowerCase();

    // Check for promo indicators in the search term
    if (normalizedSetName === normalizedSearch ||
        normalizedSetId === normalizedSearch ||
        normalizedSetName.includes(normalizedSearch) ||
        normalizedSearch.includes('promo') ||
        normalizedSearch.includes('black star')) {
      return { ...set, year: 'promo', language, isPromo: true };
    }
  }

  return null;
};

// Check if a card number indicates a promo card (e.g., "147/S-P", "SM04", "SWSH020")
export const isPromoCardNumber = (cardNumber) => {
  if (!cardNumber) return false;
  const normalized = cardNumber.toUpperCase();

  // Japanese promo patterns: S-P, SM-P, XY-P
  if (normalized.includes('/S-P') || normalized.includes('/SM-P') || normalized.includes('/XY-P')) {
    return true;
  }

  // English promo patterns: SWSH020, SM04, XY89, BW54
  if (/^(SWSH|SM|XY|BW|DP|HGSS)\d+$/.test(normalized)) {
    return true;
  }

  return false;
};

// Find set by name (fuzzy match) - searches specific language
export const findSetByName = (searchName, language = 'en') => {
  if (!searchName) return null;

  const normalizedSearch = searchName.toLowerCase().trim();

  // First check promo sets
  const promoMatch = findPromoSet(searchName, language);
  if (promoMatch) {
    return promoMatch;
  }

  const languageSets = SETS_BY_LANGUAGE[language] || ENGLISH_SETS_BY_YEAR;

  for (const [year, sets] of Object.entries(languageSets)) {
    for (const set of sets) {
      const normalizedSetName = set.name.toLowerCase();

      // Exact match
      if (normalizedSetName === normalizedSearch) {
        return { ...set, year, language };
      }

      // Partial match (e.g., "151" matches "Pokemon 151")
      if (normalizedSetName.includes(normalizedSearch) || normalizedSearch.includes(normalizedSetName)) {
        return { ...set, year, language };
      }

      // Number-only match for sets like "151"
      if (/^\d+$/.test(normalizedSearch)) {
        if (normalizedSetName.includes(normalizedSearch)) {
          return { ...set, year, language };
        }
      }
    }
  }

  return null;
};

// Find set by name across ALL languages
export const findSetByNameAllLanguages = (searchName) => {
  if (!searchName) return null;

  for (const language of Object.keys(SETS_BY_LANGUAGE)) {
    const result = findSetByName(searchName, language);
    if (result) {
      return result;
    }
  }

  return null;
};

// Get all sets as flat array with year info
export const getAllSets = (language = 'en') => {
  const allSets = [];
  const languageSets = SETS_BY_LANGUAGE[language] || ENGLISH_SETS_BY_YEAR;

  for (const [year, sets] of Object.entries(languageSets)) {
    for (const set of sets) {
      allSets.push({ ...set, year, language });
    }
  }
  return allSets;
};

// Check if a set ID belongs to a specific year
export const isSetFromYear = (setId, year, language = 'en') => {
  const sets = getSetsByYear(year, language);
  return sets.some(s => s.id.toLowerCase() === setId.toLowerCase());
};

// Find which year a set belongs to
export const getYearForSet = (setId, language = 'en') => {
  const languageSets = SETS_BY_LANGUAGE[language] || ENGLISH_SETS_BY_YEAR;

  for (const [year, sets] of Object.entries(languageSets)) {
    if (sets.some(s => s.id.toLowerCase() === setId.toLowerCase())) {
      return year;
    }
  }
  return null;
};

// Get all years that have sets for a language
export const getAllYears = (language = 'en') => {
  const languageSets = SETS_BY_LANGUAGE[language] || ENGLISH_SETS_BY_YEAR;
  return Object.keys(languageSets).sort((a, b) => b - a); // Descending order (newest first)
};

// Find set by ID
export const findSetById = (setId, language = 'en') => {
  const languageSets = SETS_BY_LANGUAGE[language] || ENGLISH_SETS_BY_YEAR;

  for (const [year, sets] of Object.entries(languageSets)) {
    const found = sets.find(s => s.id.toLowerCase() === setId.toLowerCase());
    if (found) {
      return { ...found, year, language };
    }
  }
  return null;
};

// Generate set list string for AI prompt (language-specific)
export const generateSetListForPrompt = (language = 'en') => {
  const lines = [];
  const languageSets = SETS_BY_LANGUAGE[language] || ENGLISH_SETS_BY_YEAR;
  const years = Object.keys(languageSets).sort((a, b) => b - a);

  for (const year of years) {
    const sets = languageSets[year];
    if (sets && sets.length > 0) {
      const setNames = sets.map(s => s.name).join(', ');
      lines.push(`${year}: ${setNames}`);
    }
  }

  return lines.join('\n');
};

// Get all valid set names for a language (for AI prompt validation)
export const getAllSetNames = (language = 'en') => {
  const allSets = getAllSets(language);
  return allSets.map(s => s.name);
};

export default SETS_BY_YEAR;
